var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPart1GuidesIcon = function SvgPart1GuidesIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5B5A",
    d: "M5.487 5.662 8.473 6.9a.37.37 0 0 0 .298 0l3.17-1.374a.191.191 0 0 0 0-.352L7.892 3.501a.7.7 0 0 0-.58 0l-1.826.764a.764.764 0 0 0 0 1.405z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5B5A",
    d: "M18.852 5.456a1.89 1.89 0 0 0-1.04-1.031 1.86 1.86 0 0 0-1.458 0L6.235 8.824a.37.37 0 0 1-.32 0l-1.818-.917a.76.76 0 0 0-.641 0l-1.986.84a.764.764 0 0 0-.433.92c.036.12.1.229.189.318l2.863 2.864a.76.76 0 0 0 .825.206l4.323-1.757a.2.2 0 0 1 .206.038.21.21 0 0 1 .046.207L7.96 15.529a.76.76 0 0 0 .207.832c.14.128.322.198.511.199a.7.7 0 0 0 .344-.084l2.07-1.031a.76.76 0 0 0 .343-.344L14.3 9.374a.35.35 0 0 1 .206-.184l3.314-1.237a1.91 1.91 0 0 0 1.04-2.497z"
  })));
};
export { SvgPart1GuidesIcon as ReactComponent };